import type * as React from 'react';
import { SinglePhone as SinglePhoneComponent } from '../../components/SinglePhone';
import { useSelector } from 'react-redux';
import { firstBuilderSelector } from '../../selectors/newbuilding';

interface ISinglePhoneProps {
  phone: string;
}

export const SinglePhone = ({ phone }: ISinglePhoneProps): React.JSX.Element => {
  const builder = useSelector(firstBuilderSelector);

  return <SinglePhoneComponent phone={phone} availability={builder.workTimeInfo} />;
};
